// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c930ce {
  align-items: center;
  color: var(--base-text);
  display: inline-flex;
  position: relative;
}
.a6b859 {
  color: var(--base-text-disabled);
}
.db1aa7 {
  margin-inline-start: 8px;
  cursor: pointer;
}
.d76c69 {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}
.d76c69:checked + .d709c6 {
  background-color: var(--base-quaternary-interactive-active);
  border-color: var(--base-quaternary-interactive-active);
}
.d76c69:checked + .d709c6::before {
  left: 19px;
  border-color: var(--base-quaternary-interactive-active);
}
html[dir="rtl"] .d76c69:checked + .d709c6::before {
  left: 0;
  right: 19px;
}
.d76c69:checked + .c5669e::before {
  background-color: var(--base-background-card);
}
.d709c6 {
  cursor: pointer;
  border: 1px solid var(--base-quaternary-interactive);
  display: block;
  transition: background-color 300ms ease-out, border-color 300ms ease-out;
  border-radius: 12px;
  height: 24px;
  min-width: 40px;
}
.d709c6::before {
  background-color: var(--base-background-card);
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  border: 1px solid var(--base-quaternary-interactive);
  transition: left 300ms ease-out, border-color 300ms ease-out;
  border-radius: 50%;
  transform: translateY(-50%);
  top: 50%;
  left: 3px;
}
html[dir="rtl"] .d709c6::before {
  transition: right 300ms ease-out, border-color 300ms ease-out;
  left: 0;
  right: 3px;
}
.c5669e::before {
  background-color: var(--base-quaternary-interactive-disabled);
  border-color: var(--base-quaternary-interactive-disabled);
}
.c5669e {
  border: 1px solid var(--base-quaternary-interactive-disabled);
  background-color: var(--base-interactive-disabled);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/InputControls/ToggleSwitch/ToggleSwitch.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EAEU,wBAAwB;EAChC,eAAe;AACjB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,2DAA2D;EAC3D,uDAAuD;AACzD;AACA;EACE,UAAU;EACV,uDAAuD;AACzD;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,oDAAoD;EACpD,cAAc;EACd,wEAAwE;EACxE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oDAAoD;EACpD,4DAA4D;EAC5D,kBAAkB;EAClB,2BAA2B;EAC3B,QAAQ;EACR,SAAS;AACX;AACA;EACE,6DAA6D;EAC7D,OAAO;EACP,UAAU;AACZ;AACA;EACE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,6DAA6D;EAC7D,kDAAkD;AACpD","sourcesContent":[".c930ce {\n  align-items: center;\n  color: var(--base-text);\n  display: inline-flex;\n  position: relative;\n}\n.a6b859 {\n  color: var(--base-text-disabled);\n}\n.db1aa7 {\n  -webkit-margin-start: 8px;\n          margin-inline-start: 8px;\n  cursor: pointer;\n}\n.d76c69 {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.d76c69:checked + .d709c6 {\n  background-color: var(--base-quaternary-interactive-active);\n  border-color: var(--base-quaternary-interactive-active);\n}\n.d76c69:checked + .d709c6::before {\n  left: 19px;\n  border-color: var(--base-quaternary-interactive-active);\n}\nhtml[dir=\"rtl\"] .d76c69:checked + .d709c6::before {\n  left: 0;\n  right: 19px;\n}\n.d76c69:checked + .c5669e::before {\n  background-color: var(--base-background-card);\n}\n.d709c6 {\n  cursor: pointer;\n  border: 1px solid var(--base-quaternary-interactive);\n  display: block;\n  transition: background-color 300ms ease-out, border-color 300ms ease-out;\n  border-radius: 12px;\n  height: 24px;\n  min-width: 40px;\n}\n.d709c6::before {\n  background-color: var(--base-background-card);\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  border: 1px solid var(--base-quaternary-interactive);\n  transition: left 300ms ease-out, border-color 300ms ease-out;\n  border-radius: 50%;\n  transform: translateY(-50%);\n  top: 50%;\n  left: 3px;\n}\nhtml[dir=\"rtl\"] .d709c6::before {\n  transition: right 300ms ease-out, border-color 300ms ease-out;\n  left: 0;\n  right: 3px;\n}\n.c5669e::before {\n  background-color: var(--base-quaternary-interactive-disabled);\n  border-color: var(--base-quaternary-interactive-disabled);\n}\n.c5669e {\n  border: 1px solid var(--base-quaternary-interactive-disabled);\n  background-color: var(--base-interactive-disabled);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
